<template>
  <b-modal
    :id="id"
    :ref="id"
    ok-title="บันทึกข้อมูล"
    ok-variant="success"
    :ok-disabled="!isAllowEditing"
    cancel-title="ปิด"
    title="บันทึก/แสดงข้อมูลเช็ค"
    size="lg"
    @hide="onClose"
    @ok="onSubmit"
  >
    <template v-if="project">
      <table class="table table-borderless">
        <tr>
          <th class="text-right" width="200">ชื่อโครงการ</th>
          <td>{{ project.name }}</td>
        </tr>
        <tr>
          <th class="text-right">หน่วยงาน</th>
          <td>{{ project.group.name }}</td>
        </tr>
        <tr>
          <th class="text-right">ที่ปรึกษาโครงการ</th>
          <td>{{ project.advisor.name }}</td>
        </tr>
      </table>
      <hr>
      <table class="table table-bordered mb-0">
        <tbody>
          <tr>
            <td class="align-middle">
              <strong>เลขที่เอกสาร</strong>
            </td>
            <td class="align-middle">
              <b-input-group v-if="isAllowEditing" prepend="ที่ อว 7001.03/">
                <b-form-input v-model.number="form.docNo" type="text" />
              </b-input-group>
              <span v-else>ที่ อว 7001.03/{{ project.check.docNo }}</span>
            </td>
          </tr>
          <tr>
            <td class="align-middle">
              <strong>เช็คเลขที่</strong>
            </td>
            <td class="align-middle">
              <b-form-input v-if="isAllowEditing" v-model.trim="form.no" />
              <span v-else>{{ project.check.no }}</span>
            </td>
          </tr>
          <tr>
            <td class="align-middle">
              <strong>ผู้รับเงิน</strong>
            </td>
            <td class="align-middle">
              <b-form-input v-if="isAllowEditing" v-model.trim="form.payee" />
              <span v-else>{{ project.check.payee }}</span>
            </td>
          </tr>
          <tr>
            <td class="align-middle">
              <strong>จำนวนเงิน</strong>
            </td>
            <td class="align-middle">
              <b-input-group v-if="isAllowEditing" append="บาท">
                <b-form-input v-model.number="form.amount" type="number" min="0" />
              </b-input-group>
              <span v-else>{{ project.check.amount | numeral('0,0.00') }}</span>
            </td>
          </tr>
          <tr>
            <td class="align-middle">
              <strong>เช็คลงวันที่</strong>
            </td>
            <td class="align-middle">
              <v-date-picker
                v-if="isAllowEditing"
                v-model="form.date"
                :popover="{ visibility: 'click' }"
                color="orange"
                locale="th"
              />
              <span v-else>{{ formatDate(project.check.date.date) }}</span>
            </td>
          </tr>
          <tr>
            <td class="align-middle">
              <strong>แนบไฟล์ Pay-In</strong>
            </td>
            <td class="align-middle">
              <b-form-file
                v-if="isAllowEditing"
                v-model="form.payIn"
                placeholder="เลือกไฟล์..."
                drop-placeholder="ลากและวางไฟล์ที่นี่"
                type="pdf"
              />
              <span v-else><a :href="urlDownload + '/' + project.check.payIn" target="_blank">ดาวน์โหลดเอกสาร</a></span>
              <span v-if="enableEditMode" class="text-muted small">หากไม่ต้องการเปลี่ยนแปลงไฟล์ Pay-In ที่เคยอัปโหลดไปก่อนหน้านี้ ให้เว้นว่างไว้</span>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
    <template slot="modal-footer">
      <div class="w-100 d-flex justify-content-between">
        <div>
          <b-button
            :variant="enableEditMode === true ? 'danger' : 'warning'"
            @click="toggleEditMode"
          >
            {{ enableEditMode === true ? 'ยกเลิก' : 'แก้ไข' }}
          </b-button>
        </div>
        <div>
          <b-button
            class="mr-2"
            @click="onClose"
          >
            ปิด
          </b-button>
          <b-button
            v-if="isAllowEditing"
            variant="success"
            @click="onSubmit"
          >
            บันทึก
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    id: { type: String, required: true },
    projectId: { type: String, default: null }
  },
  data () {
    return {
      form: { no: '', payee: '', date: '', docNo: '', amount: 0, payIn: null },
      urlDownload: process.env.VUE_APP_FILES_ROOT,
      enableEditMode: false
    }
  },
  computed: {
    project () { return this.$store.getters['checking/getCheckingById'](this.projectId) },
    isAllowEditing () { return this.project ? (this.project.checkingStatus !== 'Issued' || this.enableEditMode) : false }
  },
  watch: {
    projectId (newId) {
      if (!newId) { return }
      this.form.payee = this.project.advisor.name
      this.$refs[this.id].show()
    }
  },
  methods: {
    formatDate (date) {
      let Datetime = new Date(date)
      return `${Datetime.toLocaleDateString('th-TH', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      })}`
    },
    async onSubmit (event) {
      event.preventDefault()
      await this.$store.dispatch('checking/updateChecking', { projectId: this.project.id, form: this.form })
      this.$bvToast.toast('บันทึกการเปลี่ยนแปลงสำเร็จ', {
        title: 'แจ้งเตือน',
        variant: 'success',
        solid: true,
        noCloseButton: true
      })
      this.enableEditMode = false
    },
    onClose (event) {
      this.$nextTick(() => { this.$refs[this.id].hide() })
      this.form = { no: '', payee: '' }
      this.enableEditMode = false
      this.$emit('close')
    },
    toggleEditMode (event) {
      console.log(moment(this.project.check.date.date))
      if (this.project.check) {
        this.form.no = this.project.check.no
        this.form.payee = this.project.check.payee
        this.form.date = moment.utc(this.project.check.date.date).toDate()
        this.form.docNo = this.project.check.docNo
        this.form.amount = this.project.check.amount
        this.form.payIn = null
      }
      this.enableEditMode = !this.enableEditMode
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  &:first-child {
    background-color: #f2f2f2;
    width: 220px;
    p {
      margin-bottom: 0;
      font-size: $font-size-sm * 0.9;
      color: $gray-600;
    }
  }
}
</style>
